import { Typography } from "@fullscript/aviary-web";

import { useStoreConfigQuery } from "@shared/data/queries/StoreConfigQuery/StoreConfig.query.generated";

import * as styles from "./CustomAuthDisclaimer.styles";

interface Props {
  storeSlug: string;
}

export const CustomAuthDisclaimer = ({ storeSlug }: Props) => {
  const { data: storeConfigData } = useStoreConfigQuery({
    variables: { storeSlug },
    skip: !storeSlug,
  });

  const disclaimer = storeConfigData?.viewer?.storefrontConfig?.customAuthDisclaimer;

  if (!disclaimer) return;

  return (
    <div css={styles.container}>
      <div css={styles.content}>
        <Typography variant="footnote" intention="neutral" colorIntensity="subtle">
          {disclaimer}
        </Typography>
      </div>
    </div>
  );
};
